import { createBrowserHistory } from 'history';
import { container } from 'tsyringe';
import { Authentication } from '../app/cross-cutting-concerns/authentication/Authentication';
import { AuthenticationService } from '../app/cross-cutting-concerns/authentication/AuthenticationService';
import { InvalidUserPoolProviderName } from '../app/cross-cutting-concerns/authentication/errors/InvalidUserPoolProviderName';
import { AmGraphQlClient } from '../app/cross-cutting-concerns/communication/clients/AmGraphQlClient';
import { PraGraphQlClient } from '../app/cross-cutting-concerns/communication/clients/PraGraphQlClient';
import { RestClientFactory } from '../app/cross-cutting-concerns/communication/clients/RestClientFactory';
import { InvalidApiUrlError } from '../app/cross-cutting-concerns/communication/errors/InvalidApiUrlError';
import { LocalStorageAdapter } from '../app/cross-cutting-concerns/storage/adapters/LocalStorageAdapter';
import { Styling } from '../app/cross-cutting-concerns/styling/Styling';
import { FooService } from '../app/modules/foo-management/FooService';
import { InvalidAwsRegionError } from '../lib/errors/InvalidAwsRegionError';
import { isNonEmptyEnvVar } from '../lib/utils/env-variables/isNonEmptyEnvVar';
import { userPoolConfig } from './user-pool-config';

export const registerEnvVariables = (): void => {
  if (!isNonEmptyEnvVar(process.env.REACT_APP_AM_API_GRAPHQL_HTTP_ENDPOINT)) {
    throw new InvalidApiUrlError('AM API url not specified or not a string.');
  }

  if (!isNonEmptyEnvVar(process.env.REACT_APP_PRA_API_GRAPHQL_HTTP_ENDPOINT)) {
    throw new InvalidApiUrlError('PRA API url not specified or not a string.');
  }

  if (!isNonEmptyEnvVar(process.env.REACT_APP_AWS_REGION)) {
    throw new InvalidAwsRegionError();
  }

  if (!isNonEmptyEnvVar(process.env.REACT_APP_AWS_USER_POOL_PROVIDER_NAME)) {
    throw new InvalidUserPoolProviderName();
  }

  container.register('AmApiGraphqlHttpEndpoint', {
    useValue: process.env.REACT_APP_AM_API_GRAPHQL_HTTP_ENDPOINT,
  });

  container.register('PraApiGraphqlHttpEndpoint', {
    useValue: process.env.REACT_APP_PRA_API_GRAPHQL_HTTP_ENDPOINT,
  });

  container.register('AwsRegion', {
    useValue: process.env.REACT_APP_AWS_REGION,
  });

  container.register('UserPoolProviderName', {
    useValue: process.env.REACT_APP_AWS_USER_POOL_PROVIDER_NAME,
  });
};

export const registerDependencies = (): void => {
  registerEnvVariables();

  container.register('AmGraphQlClient', {
    useClass: AmGraphQlClient,
  });

  container.register('PraGraphQlClient', {
    useClass: PraGraphQlClient,
  });

  container.register('RestClient', {
    useValue: RestClientFactory.create(),
  });

  container.register('Styling', {
    useClass: Styling,
  });

  container.register('FooService', {
    useClass: FooService,
  });

  container.register('AuthenticationService', {
    useClass: AuthenticationService,
  });

  container.register('History', {
    useValue: createBrowserHistory(),
  });

  container.register('Authentication', {
    useClass: Authentication,
  });

  container.register('BrowserStorageAdapter', {
    useClass: LocalStorageAdapter,
  });

  container.register('UserPoolConfig', {
    useValue: userPoolConfig,
  });
};
